import React from 'react'
import styles from './nav-link.styles'
import injectSheet from 'react-jss'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'

const NavLink = ({ classes, children, path, location }) => (
  <li
    className={classNames(classes.link, {
      [classes.activeLink]:
        location.pathname.split('/')[3] === path.split('/')[3]
    })}>
    <Link className={classes.link} to={path}>
      <span className={classes.inner}>{children}</span>
    </Link>
  </li>
)

export default withRouter(injectSheet(styles)(NavLink))
